// packages/world-model/src/traits/door/index.ts

export { DoorTrait } from './doorTrait';
export { DoorBehavior } from './doorBehavior';
